export default "__VITE_ASSET__016b12cd__"